import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import classNames from 'classnames';
import React from 'react';
import styles from './PageSwitcher.module.css';

type Props = {
  facebookPage?: EnhancedBillingPage;
  onMenuClick: () => void;
  isMobile?: boolean;
};

export const PageSwitcher = (props: Props) => {
  const { facebookPage, onMenuClick, isMobile } = props;

  if (!facebookPage) {
    return <></>;
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.mobileWrapper]: isMobile,
      })}
      onClick={onMenuClick}
    >
      <div className={styles.pageName}>{facebookPage.name}</div>
      <div className={styles.menuIconWrapper}>
        <span className={styles.longLine} />
        <span className={styles.shortLine} />
        <span className={styles.longLine} />
      </div>
    </div>
  );
};
